<template>
    <div>
        <div v-show="!showForm && customer">
            <form-advanced-select
                    :name="name"
                    :slug="name"
                    :validations="['required']"
                    :values="addresses"
                    ref="address"
                    @change="setSelectedAddress"
                    :value="initialValue ? initialValue.id : null"
            >
                <div slot="placeholder" class="uk-padding-small uk-padding-remove-horizontal">
                    {{ $t('rubinred.ecommerce.orders.checkout.step-2.pick_address') }}
                </div>
                <div slot="item" slot-scope="{item, index}" class="uk-padding-small uk-padding-remove-horizontal uk-flex uk-flex-wrap uk-flex-between@s">
                    <div class="uk-width-1-2@s">
                        <span class="uk-text-bold">{{ item.first_name }} {{ item.last_name }}</span><br/>
                        {{ item.street }}<br/>
                        {{ item.city }} {{ item.postcode }}<br/>
                    </div>
                    <div class="uk-width-1-2@s uk-text-right@s">
                        <span v-if="item.present.region">{{ item.present.region }}<br></span>
                        {{ item.present.country }}
                    </div>
                </div>
            </form-advanced-select>
            <p>
                <a class="uk-button uk-button-link" @click="editAddress" v-show="canEditAddress">
                    <i class="fal fa-pencil"></i> {{ $t('frontend-action.edit') }}
                </a>
                <a class="uk-button uk-button-link uk-margin-left" @click="addAddress" v-show="canAddAddress">
                    <i class="fal fa-plus"></i> {{ $t('frontend-action.add') }}
                </a>
            </p>
        </div>
        <div v-show="showForm || !customer">
            <address-form class="uk-form-stacked" ref="form" :address-type="addressType"
                          :allow-only-one-billing-address="allowOnlyOneBillingAddress"
                          :previous-billing-address="previousBillingAddress"
                          :edit-address="selectedAddress ? selectedAddress.id : null">
                <slot slot="fields" name="form-fields"></slot>
            </address-form>
            <div class="uk-align-right uk-margin-top" v-if="customer">
                <button @click="discardForm" class="uk-button uk-button-default">
                    {{ $t('frontend-action.back') }}
                </button>
                <button @click="submitAddress" class="uk-button uk-button-primary">{{ $t('frontend-action.save') }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
  export default {
    props: {
      allowOnlyOneBillingAddress: {
        type: Boolean,
        default: false,
      },
      previousBillingAddress: {
        type: Number,
      },
      customer: {
        type: Boolean,
      },
      name: {
        type: String,
        required: true,
      },
      initialValue: {
        type: Object,
        default: null,
      },
      addressType: {
        type: String,
        default: null,
      }
    },
    mounted() {
      if(! this.customer && this.initialValue) {
        this.$refs.form.setValues(this.initialValue);
      }
    },
    data() {
      return {
        showForm: false,
        selectValue: this.initialValue ? this.initialValue.id : null,
        creatingAddress: false,
      };
    },
    computed: {
      selectedAddress() {
        return this.selectValue ? this.addresses[this.selectValue] : null;
      },
      canEditAddress() {
        return !!this.selectedAddress;
      },
      canAddAddress() {
        if (this.allowOnlyOneBillingAddress) {
          return this.addresses.length == 0;
        }

        return true
      },
      addresses() {
        if(this.addressType) {
          return this.$store.getters['addressBook/'+this.addressType+'Addresses'];
        }

        return this.$store.state.addressBook.addresses;
      },
    },
    methods: {
      validate() {
        if(this.customer) {
          return !! this.selectValue;
        }

        return this.$refs.form.performValidation();
      },

      getValues() {
        if(this.customer) {
          return {[this.name]: this.selectValue};
        }

        return {[this.name]: this.$refs.form.getValues()};
      },

      editAddress() {
        this.creatingAddress = false;
        this.$refs.form.setValues(this.selectedAddress, false);
        this.$refs.form.resetValidations();
        this.showForm = true;
        App.UIkit.update();
      },
      addAddress() {
        this.creatingAddress = true;
        this.$refs.form.resetValues();
        this.$refs.form.resetValidations();
        this.showForm = true;
        App.UIkit.update();
      },
      discardForm() {
        this.showForm = false;
      },
      setSelectedAddress(value) {
        this.selectValue = value;
      },
      submitAddress() {
        if (this.$refs.form.performValidation()) {
          this.$refs.form.fields.forEach(field => {
            if (field.slug === 'vat' || field.slug === 'fiscal_code') {
              field.enabled = !field.disabled;
            }
          });
          let data = this.$refs.form.getValues();
          if(! this.creatingAddress) {
            data.id = this.selectedAddress.id;
          }
          this.$store.dispatch('addressBook/submit', data).then(response => {
            if(response.data.success) {
              if(this.creatingAddress) {
                this.$refs.address.setValue(response.data.address.id);
                this.selectValue = response.data.address.id;
              }
              this.discardForm();
            }
          });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/AddressPicker.vue